var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGzSecurity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69 53.92V69H39.17V53.92a4.92 4.92 0 015-4.92H53v15.74l1.5 1.58 1.5-1.65V49h8a4.931 4.931 0 015 4.92zM43.39 30.58l11.08-8.08 11.09 8-2.79 3.5H46.18l-2.79-3.42zM52.47 29a2 2 0 104 0 2 2 0 00-4 0zm-6.21 8a8.379 8.379 0 1016.43 0H46.26zM41 41H29.83v-8H24v8H11V21.74l15.84-11.29L43 21.75v3.61l4-3v-2.7L26.82 5.55 7 19.68v25.26h34V41zm-4.17-14.06V21H31v5.92l5.83.02zm-14 0V21H17v5.92l5.83.02z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/GZ_Security.78e91142.svg";
export { SvgGzSecurity as ReactComponent };